import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import * as Globals from '../../globals';
import { Observable, of } from 'rxjs';

import { LocalStorage } from '@ngx-pwa/local-storage';
import { PayloadService } from '../payload/payload.service';
import { tap, switchMap } from 'rxjs/operators';

@Injectable({
    providedIn: 'root'
})
export class CallsService {

    constructor(
        private http: HttpClient,
        public localStorage: LocalStorage,
        public payloadService: PayloadService
    ) { }

    report(payload: string, month: number, year: number): Observable<any> {
        return this.http.post(Globals.url_api + "calls/report", {
            "payload": payload,
            "month": month,
            "year": year
        });
    }

    list(month, year, call_type, phone_type, status): Observable<any> {
        return this.payloadService.getPayload().pipe(
            switchMap(
                (payload) =>{
                    return this.http.post(Globals.url_api + "calls/list", {
                        "payload": payload,
                        "month" : month,
                        "year": year,
                        "call_type": call_type,
                        "phone_type" : phone_type,
                        "status" : status
                    });
                }
            )
        )
    }
}
